export default "__VITE_ASSET__B4qot9re__"